<template>
  <div class="PartnerCon indexMain">
    <div class="title">
      <div class="t_cn">合作伙伴</div>
      <div class="t_en">COOPERATIVE PARTNER</div>
    </div>
    <div class="cont"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.PartnerCon {
  position: relative;
  .cont {
    width: 100%;
    height: 17.71vw;
    background: url("../../assets/images/index/PartnerCon.png") center no-repeat;
    background-size: 100%;
  }
}
@media (min-width: 1920px) {
  .PartnerCon {
    position: relative;
    .cont {
      width: 100%;
      height: 340px;
      background: url("../../assets/images/index/PartnerCon.png") center
        no-repeat;
      background-size: 100%;
    }
  }
}
</style>